import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import { hasUnsafeContent, sanitizeHtml } from '@/features/CampaignsEmail/utils/sanitizeHtml';
function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(String(e.target?.result ?? ''));
        reader.onerror = () => reject(new Error('Erro ao ler o arquivo HTML'));
        reader.readAsText(file);
    });
}
export function useOpenSendTestEmailDialog(params) {
    const { title, template, creationType, htmlFile } = params;
    const { t } = useI18n();
    const toast = useToast();
    const isTestEmailModalOpen = ref(false);
    const testTemplateForModal = ref('');
    async function openSendEmailTestDialog() {
        const titleValue = (title.value || '').trim();
        if (!titleValue) {
            toast.error(t('breadcrumb.email.campaign.send-email-test-dialog.errors.missing-title-before'), { timeout: 4000 });
            return;
        }
        let nextTemplate = template.value || '';
        if (!nextTemplate || nextTemplate.trim().length === 0) {
            if ((creationType.value === 'upload' || creationType.value === 'html') && htmlFile.value) {
                try {
                    const htmlContent = await readFileAsText(htmlFile.value);
                    if (hasUnsafeContent(htmlContent)) {
                        toast.warning('O arquivo HTML contém elementos potencialmente perigosos que serão removidos automaticamente durante a sanitização.', { timeout: 5000 });
                    }
                    const sanitized = sanitizeHtml(htmlContent);
                    if (!sanitized || sanitized.trim().length === 0) {
                        toast.error(t('breadcrumb.email.campaign.send-email-test-dialog.errors.missing-template-before'), {
                            timeout: 4000,
                        });
                        return;
                    }
                    nextTemplate = sanitized;
                }
                catch (error) {
                    const message = error instanceof Error ? error.message : 'Erro ao ler o arquivo HTML';
                    toast.error(message, { timeout: 4000 });
                    return;
                }
            }
            else {
                toast.error(t('breadcrumb.email.campaign.send-email-test-dialog.errors.missing-template-before'), {
                    timeout: 4000,
                });
                return;
            }
        }
        testTemplateForModal.value = nextTemplate;
        isTestEmailModalOpen.value = true;
    }
    return {
        isTestEmailModalOpen,
        testTemplateForModal,
        openSendEmailTestDialog,
    };
}
